import React from 'react';
import type { BuilderStanceRow } from '../types/builder.types';
import { SERENITY_STANCE_COLORS } from '../constants/serenityPalette';

/** Barra lateral mínima: solo color y gestión de columnas (etiquetas en el lienzo). */
export function StanceColorRail({
  stances,
  onChange,
  minStances = 2,
}: {
  stances: BuilderStanceRow[];
  onChange: (stances: BuilderStanceRow[]) => void;
  minStances?: number;
}) {
  const updateColor = (index: number, colorId: string) => {
    onChange(stances.map((s, i) => (i === index ? { ...s, colorId } : s)));
  };

  const addStance = () => {
    const used = new Set(stances.map((s) => s.colorId));
    const next = SERENITY_STANCE_COLORS.find((c) => !used.has(c.id))?.id ?? 'lavender';
    onChange([...stances, { id: `stance_${stances.length + 1}`, label: `Postura ${stances.length + 1}`, colorId: next }]);
  };

  const removeStance = (index: number) => {
    if (stances.length <= minStances) return;
    onChange(stances.filter((_, i) => i !== index));
  };

  return (
    <div className="stance-color-rail space-y-3">
      <p className="text-[10px] font-medium uppercase tracking-[0.14em] text-slate-400">
        Colores · columnas
      </p>
      <ul className="space-y-2">
        {stances.map((stance, index) => (
          <li key={stance.id} className="stance-color-rail__row">
            <span className="stance-color-rail__idx">{index + 1}</span>
            <div className="flex flex-wrap gap-1">
              {SERENITY_STANCE_COLORS.map((swatch) => (
                <button
                  key={swatch.id}
                  type="button"
                  className="builder-color-swatch builder-color-swatch--sm"
                  data-selected={stance.colorId === swatch.id}
                  style={{ background: swatch.hex }}
                  title={swatch.label}
                  aria-pressed={stance.colorId === swatch.id}
                  onClick={() => updateColor(index, swatch.id)}
                />
              ))}
            </div>
            <button
              type="button"
              className="stance-color-rail__remove"
              disabled={stances.length <= minStances}
              onClick={() => removeStance(index)}
              aria-label="Eliminar columna"
            >
              ✕
            </button>
          </li>
        ))}
      </ul>
      <button type="button" className="studio-rail-btn w-full" onClick={addStance}>
        + Columna
      </button>
    </div>
  );
}
